import { apiFetch } from './api';

// The events API answers validation and permission errors with a plain-text message.
const readError = async (res, fallback) => {
  const text = await res.text().catch(() => '');
  return text && !text.trim().startsWith('{') ? text : fallback;
};

const request = async (endpoint, method, body, fallback) => {
  const res = await apiFetch(endpoint, {
    method,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (!res.ok) {
    throw new Error(await readError(res, fallback));
  }
  return res.status === 204 ? null : res.json();
};

export const fetchGroupEvents = (groupId) =>
  request(`/groups/${groupId}/events`, 'GET', undefined, 'Failed to load events');

export const fetchPendingPayments = (groupId) =>
  request(`/groups/${groupId}/pending-payments`, 'GET', undefined, 'Failed to load pending payments');

export const createEvent = (event) => request('/events', 'POST', event, 'Failed to create event');

export const updateEvent = (eventId, event) =>
  request(`/events/${eventId}`, 'PUT', event, 'Failed to update event');

export const deleteEvent = (eventId) =>
  request(`/events/${eventId}`, 'DELETE', undefined, 'Failed to delete event');

export const addEventItem = (eventId, item) =>
  request(`/events/${eventId}/items`, 'POST', item, 'Failed to add item');

export const updateEventItem = (eventId, itemId, item) =>
  request(`/events/${eventId}/items/${itemId}`, 'PUT', item, 'Failed to update item');

export const deleteEventItem = (eventId, itemId) =>
  request(`/events/${eventId}/items/${itemId}`, 'DELETE', undefined, 'Failed to delete item');

export const addEventPayment = (eventId, payment) =>
  request(`/events/${eventId}/payments`, 'POST', payment, 'Failed to record payment');

export const deleteEventPayment = (eventId, paymentId) =>
  request(`/events/${eventId}/payments/${paymentId}`, 'DELETE', undefined, 'Failed to delete payment');
